import { render, staticRenderFns } from "./ConfigWebsiteCatalogueCollections.vue?vue&type=template&id=4acc5610&scoped=true"
import script from "./ConfigWebsiteCatalogueCollections.vue?vue&type=script&lang=js"
export * from "./ConfigWebsiteCatalogueCollections.vue?vue&type=script&lang=js"
import style0 from "./ConfigWebsiteCatalogueCollections.vue?vue&type=style&index=0&id=4acc5610&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4acc5610",
  null
  
)

export default component.exports